import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  Input,
  OnChanges,
  Injector,
  Injectable,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { OptionFee } from './detail-fee/detail-fee';
import { Product } from './product.model';
import { Constant } from '../../blog/constant';
import { EventManagerService } from '../../blog/event-manager.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { DateUtil } from '../../../../common/utils/date.util';
const TABS = {
  OVERVIEW: 'overview',
  TOP_HOLDING: 'top_holding',
  HOLDING_INDEX: 'holding_index',
  INDUSTRY_DISTRIBUTION: 'industry_distribution',
  ASSET_DISTRIBUTION: 'asset_distribution',
  DOCUMENTS: 'documents',
};

@Injectable({ providedIn: 'any' })
export abstract class DetailProductFunction
  implements OnInit, OnChanges, OnDestroy
{
  @Input() isDetailFullPage: boolean = false;
  TABS = TABS;
  tab: string = TABS.OVERVIEW;
  product: Product = new Product();
  Constant = Constant;
  noteBuyFeeDiscount: any;
  buyFeesDiscount: any[] = [];
  noteSellFeeDiscount: any;
  sellFeesDiscount: any[] = [];
  isError: boolean = false;
  //chart
  typeDataChart = '12';
  navChange: number = 0;
  public lineChartData: any[] = [{ data: [], label: 'NAV/Unit (VND)' }];
  public chartData: any = {
    labels: ['title'],
    datasets: [
      {
        label: 'label',
        data: [],
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderWidth: 2,
        pointBackgroundColor: 'rgb(255, 99, 132)',
      },
    ],
  };
  approveDays: string = ' hàng tuần';
  subscriptions: Subscription[] = [];
  isBond: boolean = false;
  constructor(
    public eventManager: EventManagerService,
    public router: Router,
    public dashboardService: DashboardService
  ) {}
  ngOnInit() {
    this.subscriptions = [];
    this.product = this.product || new Product();
    this.isBond = this.product.dataFundAssetType.code === 'BOND';
    this.initData();
  }
  ngOnChanges(simpleChanges: SimpleChanges) {}
  ngOnDestroy(): void {
    if ((this.subscriptions || []).length > 0) {
      this.eventManager.destroys(this.subscriptions || []);
    }
  }
  setTimeZone() {
    this.product.extra = this.product.extra || { lastNAVDate: 0 };
    const lastNAVDate = new Date(this.product.extra.lastNAVDate);
    this.product.extra.lastNAVDate = new Date(
      lastNAVDate.setHours(lastNAVDate.getHours() + 2)
    ).getTime();
  }
  initData() {
    this.getDataChart(this.typeDataChart);
    this.updateProduct();
  }
  updateProduct() {
    this.noteSellFeeDiscount = this.sellFeesDiscount[0]
      ? this.sellFeesDiscount[0].note
      : '';
    this.product.productTopHoldingList =
      this.product.productTopHoldingList || [];
    this.product.isNewProduct =
      !this.product.isProductIpo &&
      (Date.now() - this.product.approveAt) / (24 * 60 * 60 * 1000) < 30;
  }
  getDataChart(type: any) {
    this.typeDataChart = type;
    let fromDate, toDate, navPeriod;
    const lastNAVDate = new Date(this.product.extra.lastNAVDate);
    lastNAVDate.setDate(lastNAVDate.getDate() + 1);
    toDate = DateUtil.parseDate(lastNAVDate, 'yyyyMMdd');
    let date = new Date();
    const currentTime = this.product.extra.lastNAVDate;
    const navChange = this.product.productNavChange || {};
    switch (this.typeDataChart) {
      case 'YTD':
        navPeriod = 'navToLastYear';
        this.navChange = navChange.navToLastYear;
        // date.setMonth(date.getMonth() -3);
        // date = new Date(currentTime - 91 * 86400000);
        date = DateUtil.revertDate(
          `01/01/${new Date().getFullYear()}`,
          'dd/MM/yyyy'
        );
        break;
      case '3':
        navPeriod = 'navTo3Months';
        this.navChange = navChange.navTo3Months;
        // date.setMonth(date.getMonth() -3);
        date = new Date(currentTime - 91 * 86400000);
        break;
      case '6':
        navPeriod = 'navTo6Months';
        this.navChange = navChange.navTo6Months;
        // date.setMonth(date.getMonth() -6);
        date = new Date(currentTime - 182 * 86400000);
        break;
      case '12':
        navPeriod = 'navTo12Months';
        this.navChange = navChange.navTo12Months;
        // date.setMonth(date.getMonth() - 12);
        date = new Date(currentTime - 365 * 86400000);
        break;
      case '24':
        navPeriod = 'navTo24Months';
        this.navChange = navChange.navTo24Months;
        // date.setMonth(date.getMonth() - 36);
        date = new Date(currentTime - 2 * 365 * 86400000);
        break;
      case '36':
        navPeriod = 'navTo36Months';
        this.navChange = navChange.navTo36Months;
        // date.setMonth(date.getMonth() - 36);
        date = new Date(currentTime - 3 * 365 * 86400000);
        break;
      case '60':
        navPeriod = 'navTo60Months';
        this.navChange = navChange.navTo60Months;
        date = new Date(currentTime - 5 * 365 * 86400000);
        break;
      case '84':
        navPeriod = 'navTo7Years';
        this.navChange = navChange.navTo60Months;
        date = new Date(currentTime - 7 * 365 * 86400000);
        break;
      case '120':
        navPeriod = 'navTo10Years';
        this.navChange = navChange.navTo60Months;
        date = new Date(currentTime - 10 * 365 * 86400000);
        break;
      case 'ALL':
        navPeriod = 'navToBeginning';
        this.navChange = navChange.navToBeginning;
        break;
    }
    fromDate = DateUtil.parseDate(date, 'yyyyMMdd');
    const body = {
      isAllData: type === 'ALL' ? 1 : 0,
      productId: this.product.id,
      navPeriod,
      // fromDate: type !== 'ALL' ? fromDate : null,
      // toDate: toDate || null,
    };
    this.dashboardService.getDataChart(body).subscribe((res: any) => {
      const labels = res.data.map((item: any) => {
        return item.navDate;
      });
      this.chartData = {
        dateLabels: labels,
        labels: labels,
        datasets: [
          {
            label: 'NAV',
            data: res.data.map((item: any) => {
              return item.nav;
            }),
            isColorBlue: true,
            isFill: false,
          },
        ],
        dividendDates: (res.extra || {}).dividendDates,
      };
    });
  }
  buy() {
    if (this.isDetailFullPage) {
      const message = `patners://buy-fund/{"code": ${this.product.code}}`;
      window.location.href = message;
      return;
    }
    if (typeof window !== 'undefined') {
      window.open(
        Constant.url_login + '?productId=' + this.product.id,
        '_self'
      );
    }
    this.dismiss();
  }
  dismiss() {
    if (this.isDetailFullPage) {
      const message = `patners://close-popup-detail-fund`;
      window.location.href = message;
      return;
    }
  }
  changeTab(tab: string) {
    this.tab = tab;
  }
}
